import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import DodavanjeSredstva from "./DodavanjeSredstva";
import PretragaSredstva from "./PretragaSredstva";
import { useEffect, useState } from "react";

function MasineIUredjajiPocetna() {
  // "" - pocetna, "dodavanje", "pretraga", "edit"
  const [currentState, setCurrentState] = useState("");

  // "AKTIVNA" | "ARHIVIRANE" | "TUDJE"
  const [selectedView, setSelectedView] = useState("AKTIVNA");

  const {
    editSredstvoData,
    setIsZahtevZaPregledSredstva,
    isZahtevZaPregledSredstva
  } = useGlobalContext();

  useEffect(() => {
    setCurrentState(editSredstvoData ? "edit" : "");
  }, [editSredstvoData]);

  const handleClickDodavanje = () => {
    setCurrentState("dodavanje");
  };

  const handleClickPretraga = () => {
    setCurrentState("pretraga");
  };

  const handleClickZahtevZaPregledSredstva = () => {
    setIsZahtevZaPregledSredstva(true);
    setCurrentState("");
    setSelectedView("");
  };

  // Klik na “prikaz” samo šalje signal glavnom prozoru + utisne dugme
  const setView = (mode) => {
    setSelectedView(mode);
    window.dispatchEvent(
      new CustomEvent("machinesViewChange", {
        detail: { mode }
      })
    );
    setCurrentState("");
    setIsZahtevZaPregledSredstva(false);
  };

  // Sinhronizacija: kad glavni prozor promeni view (npr. preko NAZAD),
  // ovde se automatski “utisne” odgovarajući taster
  useEffect(() => {
    const onSync = (e) => {
      const mode = e?.detail?.mode;
      if (["AKTIVNA", "ARHIVIRANE", "TUDJE"].includes(mode)) {
        setSelectedView(mode);
      }
    };

    window.addEventListener("machinesViewSync", onSync);
    return () => window.removeEventListener("machinesViewSync", onSync);
  }, []);

  return (
    <>
      {currentState === "" && (
        <div style={{ width: "100%" }}>
          <div onClick={handleClickDodavanje}>
            <Button
              activation={true}
              style={{ padding: "10px", fontWeight: "bold", textAlign: "left" }}
            >
              ДОДАВАЊЕ МАШИНА, УРЕЂАЈА ИЛИ АЛАТА
            </Button>
          </div>

          <div onClick={handleClickPretraga}>
            <Button
              activation={true}
              style={{ padding: "10px", fontWeight: "bold", textAlign: "left" }}
            >
              ФИЛТРИРАЊЕ МАШИНА, УРЕЂАЈА ИЛИ АЛАТА
            </Button>
          </div>

          <div onClick={() => setView("AKTIVNA")}>
            <Button
              active={selectedView === "AKTIVNA"}
              style={{ padding: "10px", fontWeight: "bold", textAlign: "left" }}
            >
              АКТИВНЕ МАШИНЕ, УРЕЂАЈИ ИЛИ АЛАТИ
            </Button>
          </div>

          <div onClick={() => setView("ARHIVIRANE")}>
            <Button
              active={selectedView === "ARHIVIRANE"}
              style={{ padding: "10px", fontWeight: "bold", textAlign: "left" }}
            >
              АРХИВИРАНЕ МАШИНЕ, УРЕЂАЈИ ИЛИ АЛАТИ
            </Button>
          </div>

          <div onClick={() => setView("TUDJE")}>
            <Button
              active={selectedView === "TUDJE"}
              style={{ padding: "10px", fontWeight: "bold", textAlign: "left" }}
            >
              МАШИНЕ, УРЕЂАЈИ ИЛИ АЛАТИ У ТУЂЕМ ВЛАСНИШТВУ
            </Button>
          </div>

          <div onClick={handleClickZahtevZaPregledSredstva}>
            <Button
              active={isZahtevZaPregledSredstva}
              style={{ padding: "10px", fontWeight: "bold", textAlign: "left" }}
            >
              ЗАХТЕВ ЗА ПРЕГЛЕД И ПРОВЕРУ ОПРЕМЕ ЗА РАД
            </Button>
          </div>
        </div>
      )}

      {(currentState === "dodavanje" || editSredstvoData) && (
        <DodavanjeSredstva
          setCurrentState={setCurrentState}
          editSredstvoData={editSredstvoData}
        />
      )}

      {currentState === "pretraga" && (
        <PretragaSredstva onClose={() => setCurrentState("")} />
      )}

      {/* <div className="masine-uredjaji-notifikacije">OVDE IDU NOTIFIKACIJE</div> */}
    </>
  );
}

export default MasineIUredjajiPocetna;
